export const RACING_MODULE_NAME = 'racing';
export const RACING_MODULE_PATH = '/racing/';

export const WIN = {
    name: 'WIN',
    code: '1'
};
export const PLACE = {
    name: 'PLACE',
    code: '2'
};
export const SHOW = {
    name: 'SHOW',
    code: '3'
};
export const EXACTA = {
    name: 'EXACTA',
    code: '5'
};
export const TRIFECTA = {
    name: 'TRIFECTA',
    code: '6'
};
export const EXACTA_BOX = {
    name: 'EXACTA_BOX',
    code: '7'
};
export const TRIFECTA_BOX = {
    name: 'TRIFECTA_BOX',
    code: '8'
};

export const BET_TYPES = [
    WIN,
    PLACE,
    SHOW,
    EXACTA,
    TRIFECTA,
    EXACTA_BOX,
    TRIFECTA_BOX
];

export const RACING_MARKETS = BET_TYPES;



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/racing/constants/identifiers.js